import * as types from './eventTypes';
import { getCurrentUrl } from '../../helpers';

/**
 * Returns current url without query params and hash
 */
const commonThreeFoursEvent = {
  event: 'GA_Event',
  eventCategory: 'action_444',
  eventLabel: getCurrentUrl(),
};

export default function pushToGTM(type, data) {
  let dataLayer = [];
  if (typeof window !== 'undefined') ({ dataLayer } = window);

  try {
    switch (type) {
      case types.EVENT_444_BANNER_CLICK:
        dataLayer.push({
          ...commonThreeFoursEvent,
          eventAction: 'banner_click',
        });
        break;
      case types.EVENT_444_PHONE_VALIDATION:
        dataLayer.push({
          ...commonThreeFoursEvent,
          eventAction: `phone_${data.payload}`,
        });
        break;
      default:
        return false;
    }
  } catch (e) {
    /**
     * throw Error without breaking the main thread
     */
    setTimeout(() => {
      console.warn(`An error occurred while trying to push '${type}' to GTM`);
      throw new Error(e);
    }, 0);
    return true;
  }

  return true;
}
